// extracted by mini-css-extract-plugin
module.exports = {"container":"f0D68","slide":"_15i1a","postWrapper":"_2S3A2","separator":"_1UTOb"};